import {gql} from "@apollo/client";

// first is zero because we only want to return the totals and no specific info
export default gql`
  query getJobTimeframeStats($employerId: String, $timezone: String, $isFixedTerm: Boolean) {
    todayCount: jobs(
      first: 0
      timeframe: Today
      isActive: true
      employerId: $employerId
      timezone: $timezone
      isFixedTerm: $isFixedTerm
    ) {
      totalCount
    }
    tomorrowCount: jobs(
      first: 0
      timeframe: Tomorrow
      isActive: true
      employerId: $employerId
      timezone: $timezone
      isFixedTerm: $isFixedTerm
    ) {
      totalCount
    }
    upcomingCount: jobs(
      first: 0
      timeframe: Upcoming
      isActive: true
      employerId: $employerId
      timezone: $timezone
      isFixedTerm: $isFixedTerm
    ) {
      totalCount
    }
    draftCount: jobs(first: 0, isActive: false, employerId: $employerId, timezone: $timezone, isFixedTerm: $isFixedTerm) {
      totalCount
    }
    queueCount: jobs(first: 0, isActive: false, isQueued: true, employerId: $employerId, timezone: $timezone, isFixedTerm: false) {
      totalCount
    }
  }
`;
